/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkEventType } from '../models/work-event-type';

@Injectable({ providedIn: 'root' })
export class WorkEventTypesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `eventTypesV1ControllerFindAll()` */
  static readonly EventTypesV1ControllerFindAllPath = '/v1/event-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventTypesV1ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventTypesV1ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEventType>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventTypesService.EventTypesV1ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEventType>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventTypesV1ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventTypesV1ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkEventType>> {
    return this.eventTypesV1ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEventType>>): Array<WorkEventType> => r.body)
    );
  }

}
